import { useCallback } from "react";
import { useSearchParams, createSearchParams } from "react-router-dom";
import AllQueriesListWithFilter from "./AllQueriesListWithFilter";
import { QueryItem } from "../types";

interface AllQueriesContentProps {
  queryHash?: string;
}

const AllQueriesContent = ({ queryHash }: AllQueriesContentProps) => {
  const [searchParams] = useSearchParams();

  const getRowUrl = useCallback(
    (item: QueryItem) => {
      const startDate = searchParams.get("start_date");
      const endDate = searchParams.get("end_date");

      const params: Record<string, string> = {};
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;

      const queryParams = Object.keys(params).length > 0 ? `?${createSearchParams(params)}` : "";
      return `/query/${item.query_id}${queryParams}`;
    },
    [searchParams]
  );

  const getRowState = useCallback((item: QueryItem) => ({ entityName: item.query_id }), []);

  return (
    <AllQueriesListWithFilter
      getRowUrl={getRowUrl}
      getRowState={getRowState}
      queryHash={queryHash}
    />
  );
};

export default AllQueriesContent;
